/* eslint i18next/no-literal-string: 0 */
import React, { useEffect, useRef, memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../ui/button'

import ReactTooltip from 'react-tooltip'

import { RootState } from '../../store/rootReducer'
import { advState } from '../../store/adv/advTyping'

import { fetchAdv } from '../../store/adv/advSlice'
import { advGenders } from '../../constants'
import s from './advGroup.module.sass'
import { ref } from 'yup'

interface Props {
    user: {
        nick: string
        ufrag: string
        gender: number
        snapshot: string
        video_preview: string
    }
    isAgeVerified: boolean
}

const Snapshot: React.FunctionComponent<Props> = ({ user, isAgeVerified }: Props) => {
    const [t] = useTranslation()

    const adv = useSelector<RootState, advState>((state) => state.adv)

    const videoRef = useRef(null)

    const hoverVideo = () => {
        try {
            if (user.video_preview) {
                if (videoRef.current.paused) {
                    // @ts-ignore
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
                    ref.current.play().catch((e) => {})
                }
            }
            // eslint-disable-next-line no-empty
        } catch (e) {}
    }

    const notHoverVideo = () => {
        try {
            if (user.video_preview) {
                if (!videoRef.current.paused) videoRef.current.pause()
            }
            // eslint-disable-next-line no-empty
        } catch (e) {}
    }

    // @ts-ignore
    return (
        <div
            className={s['snapshot']}
            onClick={() => isAgeVerified && window.open(`${adv.chatScriptUrl}#u=${btoa(user.ufrag)}`)}
        >
            {user.snapshot ? <link rel="preload" as="image" href={user.snapshot} /> : <></>}
            <div className={s['snapshotMaterial']}>
                {user.video_preview ? (
                    <video
                        data-testid={'advVideo'}
                        onMouseOver={() => hoverVideo()}
                        onMouseOut={() => notHoverVideo()}
                        onTouchStart={() => hoverVideo()}
                        onTouchEnd={() => notHoverVideo()}
                        src={user.video_preview}
                        poster={user.snapshot}
                        loop
                        disablePictureInPicture={true}
                        playsInline={true}
                        preload="auto"
                        muted={true}
                        ref={videoRef}
                    />
                ) : (
                    <img src={user.snapshot} alt="video preview" />
                )}
            </div>
            <div className={s['userInfo']} style={{ opacity: 0 }}>
                <div>{user.nick}</div>
                <div>{t(advGenders[user.gender].label || '')}</div>
                <Button label={t('Online')} />
            </div>
        </div>
    )
}

interface AdvGroupProps {
    isAgeVerified: boolean
}

const AdvGroup = ({ isAgeVerified }: AdvGroupProps) => {
    const adv = useSelector<RootState, advState>((state) => state.adv)
    const dispatch = useDispatch()
    const [t] = useTranslation()

    const [isPageLoaded, setIsPAgeLoaded] = useState(false)

    useEffect(() => {
        const advInterval = setInterval(() => dispatch(fetchAdv()), 60000)
        setIsPAgeLoaded(true)
        return () => clearInterval(advInterval)
    }, [])

    return (
        <>
            {/*inline style to avoid layout shift*/}
            <div className={s['advHeader']} style={{ marginTop: '20px', paddingTop: '10px' }}>
                {t('Webcam chatting at BobTV')}
                <img
                    src={require('../../assets/ic-info-bobtv.svg')}
                    data-tip=""
                    data-for={'description'}
                    alt="adv description"
                />
                <ReactTooltip place={'bottom'} type={'light'} id="description" className={s['tooltip']}>
                    {isPageLoaded && (
                        <>
                            <p>BobTV</p>
                            <p>
                                {t('Videochat rooms to exhibit on webcam for amateur libertines and voyeurs')}.
                                {t('Nudity and sex webcams are accepted on chat rooms')}.
                            </p>
                        </>
                    )}
                </ReactTooltip>
            </div>
            {/*inline style to avoid layout shift*/}
            <div
                className={s['snapshotList']}
                style={{ marginTop: '13px', display: 'grid', gap: '8px', height: '270px' }}
            >
                {adv.users.map(
                    (item, index) => index < 5 && <Snapshot key={item.nick} user={item} isAgeVerified={isAgeVerified} />
                )}
            </div>
        </>
    )
}

export default memo(AdvGroup)
